var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-h3 black--text text-no-wrap",attrs:{"data-cy":"booking-time"}},[_vm._v(_vm._s(_vm.times))]),_c('div',{staticClass:"text-h4 black--text text-no-wrap",attrs:{"data-cy":"booking-date"}},[_vm._v("\n    "+_vm._s(_vm._f("capitalize")(_vm.date))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }